// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/bundle." + (chunkId === "276" ? "licenses" : chunkId) + "." + {"115": "6e46605912c4f991","276": "dba520b6590d8983","482": "870f5bdcce8235ce","790": "151a62d6b8c36201",}[chunkId] + ".js"
}